import { ReactElement } from 'react';

import { SvgIconProps } from '../../Components/Icons';

export function ErrorIcon(props: SvgIconProps): ReactElement {
  return (
    <svg stroke='#757575' fill='#f6f6f6' height='24' width='24' xmlns='http://www.w3.org/2000/svg' {...props.svgProps}>
      <g strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'>
        <path d='M.75 12a11.25 11.25 0 1022.5 0 11.25 11.25 0 00-22.5 0zM4.045 4.045l15.91 15.91' />
      </g>
    </svg>
  );
}
